import { Component, OnInit, Input, HostBinding } from "@angular/core";
import { PriceSettings } from "./price-display.model";
import { CurrencyPipe } from "@angular/common";

@Component({
    selector: "price",
    templateUrl: "./price-display.component.html",
    styleUrls: ["./price-display.component.scss"],
    standalone: false
})
export class PriceDisplayComponent implements OnInit {
	@Input() value: number;
	@Input() beforeText: string;
	@Input() afterText: string;

	_defaultSettings = <PriceSettings>{
		displayCurrencySymbol: true,
		displayPartial: false,
		displaySign: false,
		textSize: 14,
		valueTextSize: 22
	};

	_settings = { ...this._defaultSettings };

	@Input() set settings(value: PriceSettings) {
		this._settings = { ...this._defaultSettings, ...value };
	}

	_valueStr: string;

	constructor(private __currencyPipe: CurrencyPipe) {}

	ngOnInit() {
		this.__updateValueStr();
	}

	private __updateValueStr() {
		let digitFormat = "0.0-0";
		if (this._settings.displayPartial) {
			digitFormat = "0.2-2";
		}

		const valStr = this.__currencyPipe.transform(
			this.value,
			undefined,
			"symbol",
			digitFormat,
			"en-AU"
		);

		let sign = "";
		if (this._settings.displaySign) {
			sign = "+";
			if (this.value < 0) {
				sign = "-";
			}
		}
		this._valueStr = `${sign}${valStr}`;
	}
}
